<div class="banner-alert" *ngIf="message">
  <div class="message">{{ message }}</div>
  <div class="label">
    {{ labelModel.text }}
  </div>
</div>
